import * as React from 'react'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { ISelectControlProps } from './SelectControl'
import { GRID_CELLPADDING, GRID_CELLFONTSIZE } from './grids/consts'
import Chip from '@material-ui/core/Chip'
import Checkbox from '@material-ui/core/Checkbox'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4
  },
  chip: {
    height: 'auto',
    padding: '4px 0'
  },
  chipLabel: {
    display: 'block',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    height: 'auto',
    padding: 6,
    overflowWrap: 'break-word',
    maxWidth: '100% !important'
  },
  checkbox: {
    alignSelf: 'flex-start',
    paddingTop: 8
  },
  select: {
    maxWidth: '100% !important'
  }
})

const SelectManyControlInner: React.FC<ISelectControlProps> = (props) => {
  const styles = useStyles()
  const options = props.options || []
  const value = props.field.value || []

  const handleChange = (event: any) => {
    props.form.setFieldValue(props.field.name, event.target.value)
  }

  if (props.gridCell) {
    return (
      <div
        id={props.id}
        style={{
          padding: GRID_CELLPADDING,
          fontSize: GRID_CELLFONTSIZE,
          whiteSpace: 'normal',
          wordBreak: 'break-word'
        }}
      >
        {value.join(', ')}
      </div>
    )
  }

  return (
    <Select
      id={props.id}
      multiple
      fullWidth
      value={value}
      onChange={handleChange}
      className={styles.select}
      renderValue={(selected: any) => (
        <div className={styles.chipContainer}>
          {selected.map((optionValue: string) => (
            <Chip
              key={optionValue}
              label={
                options.find((option) => option.value == optionValue)?.label
              }
              classes={{ root: styles.chip, label: styles.chipLabel }}
            />
          ))}
        </div>
      )}
      MenuProps={{
        PaperProps: { style: { maxHeight: '60vh' } }
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          disabled={props.disabled}
          style={{
            height: 'auto',
            minHeight: 48,
            alignItems: 'flex-start'
          }}
        >
          <Checkbox
            color='primary'
            className={styles.checkbox}
            checked={
              value.find(
                (optionValue: string) => optionValue == option.value
              ) != null
            }
            disabled={props.disabled}
          />
          <ListItemText
            primary={option.label}
            primaryTypographyProps={{
              style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word'
              }
            }}
          />
        </MenuItem>
      ))}
    </Select>
  )
}

export default class SelectManyControl extends React.Component<ISelectControlProps> {
  constructor(props: any) {
    super(props)
  }

  render() {
    return <SelectManyControlInner {...this.props} />
  }
}
